import React from 'react';
import { practitionerQuery_practitioner_availability } from 'Services/BeGateway/Practitioner/__generated__/practitionerQuery';
import { useHistory } from 'react-router';
import RoutePath from 'App/RoutePath';
import { useTranslation } from 'react-i18next';
import { FieldValues, FormValues, TimeSlot } from '../../types';
import { DayPicker } from '../DayPicker';
import { TimeSelector } from '../TimeSelector';
import {
  BrowseButton,
  Container,
  Description,
  DurationLabel,
  Subheader,
} from './styles';

export interface SetFieldValue {
  (
    field: 'bookingStage' | 'selectedDate' | 'range',
    value?: FormValues[keyof FormValues] | undefined,
    shouldValidate?: boolean | undefined,
  ): void;
  (field: string, value: string): void;
}

interface BookingStageDateSelectProps {
  setFieldValue(field: string, value: unknown): void;
  setValues(values: FormValues): void;
  formValues: FormValues;
  availableTimes: practitionerQuery_practitioner_availability;
}

export default ({
  availableTimes,
  formValues,
  setValues,
  setFieldValue,
}: BookingStageDateSelectProps) => {
  const { t } = useTranslation('book', {
    keyPrefix: 'practitioner.book.noSlots',
  });
  const history = useHistory();

  const hasAvailableSlots =
    availableTimes.hasAvailability && availableTimes.times?.length;

  return (
    <Container>
      <DurationLabel duration={availableTimes.availabilityConfig?.duration} />
      <DayPicker formValues={formValues} setValues={setValues} />
      {hasAvailableSlots ? (
        <TimeSelector
          day={formValues[FieldValues.SelectedDate]}
          selectedSlot={formValues[FieldValues.SelectedSlot]}
          practitionerSlots={availableTimes.times as TimeSlot[]}
          onSelect={(slot: TimeSlot) =>
            setFieldValue(FieldValues.SelectedSlot, slot)
          }
        />
      ) : (
        <>
          <Subheader>{t('title')}</Subheader>
          <Description>{t('text')}</Description>
          <BrowseButton
            variant="primary"
            role="button"
            onClick={() => history.push(RoutePath.BookPractitioners)}
            label={t('cta')}
          />
        </>
      )}
    </Container>
  );
};
